import { Typography } from 'components'

type PricingCardProps = {
	description: string
	handleSelectPlan: (planId: string) => void
	isSelected: boolean
	planId: string
	planName: string
	price: number
}

const PricingCard = ({
	description,
	handleSelectPlan,
	isSelected,
	planId,
	planName,
	price
}: PricingCardProps) => (
	<div
		aria-label={`Select ${planName} plan`}
		className={`group flex flex-col rounded-md border border-black-800 bg-black-850 p-6 transition-all hover:bg-black-800 ${
			isSelected ? 'border-2 border-product' : 'border-black-700 border'
		}`}
		onClick={() => handleSelectPlan(planId)}
		onKeyDown={e => {
			if (e.key === 'Enter' || e.key === ' ') {
				handleSelectPlan(planId)
			}
		}}
		role='button'
		tabIndex={0}
	>
		<div class='space-y-6'>
			<Typography
				color='text-black-100 first-letter:uppercase'
				text={planName}
				variant='h4'
			/>

			<Typography
				color='text-black-200 first-letter:uppercase'
				text={description}
				variant='text2'
			/>

			<div class='mt-6 flex flex-col items-center justify-center space-y-2 2xl:flex-row 2xl:space-y-0'>
				<Typography
					color='text-black-100'
					text={`${price} USD`}
					variant='h1'
					weight='font-normal'
				/>
				<Typography
					class='ml-2 text-lg'
					color='text-black-200'
					text='per user/monthly'
					variant='label3'
					weight='font-normal'
				/>
			</div>
		</div>
	</div>
)

export { PricingCard }
